__turbopack_context__.v({
  "brand": "Qtvnjq_brand",
  "cardSubtext": "Qtvnjq_cardSubtext",
  "container": "Qtvnjq_container",
  "content": "Qtvnjq_content",
  "copy": "Qtvnjq_copy",
  "dialogue": "Qtvnjq_dialogue",
  "error": "Qtvnjq_error",
  "form": "Qtvnjq_form",
  "heading": "Qtvnjq_heading",
  "input": "Qtvnjq_input",
  "intro": "Qtvnjq_intro",
  "signInLink": "Qtvnjq_signInLink",
  "submitButton": "Qtvnjq_submitButton",
  "subtext": "Qtvnjq_subtext",
  "title": "Qtvnjq_title",
});
